import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { Image } from "react-bootstrap";

const ViewUser = () => {
  const params = useParams();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [userGroupId, setUserGroupId] = useState("");
  const [msg, setMsg] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [status, setStatus] = useState();

  const [userRole, setUserRole] = useState({});

  const [userGroups, setUserGroups] = useState([]);
  const history = useNavigate();
  const [token, setToken] = useState("");
  const [expire, setExpire] = useState("");

  const initialValues = {
    firstName: "",
    lastName: "",
    gender: "",
    driverScince: "",
    vehicleId: "",
    phoneNumber: "",
  };
  const getUser = async () => {
    axios
      .get("/user/" + params.id, {
        // headers: {
        //   Authorization: `Bearer ${this.token}`,
        // },
      })
      .then((res) => {
        // console.log(res.data);
        setFirstName(res.data.user.name);

        setPhoneNumber(res.data.user.phoneNumber);

        setGender(res.data.user.gender);
        setEmail(res.data.user.email);
        setAddress(res.data.user.address);
        setStatus(res.data.user.status);
        setSelectedImage(res.data.user.profilePicture);
        setUserGroupId(res.data.user.roleId);
      });
  };

  const refreshToken = async () => {
    try {
      const response = await axios.get("/token");
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setExpire(decoded.exp);
    } catch (error) {
      if (error.response) {
        history("/");
      }
    }
  };

  const getRoles = async () => {
    const response = await axios.get("/roles", {
      // headers: {
      //     Authorization: `Bearer ${token}`
      // }
    });
    // console.log(response.data);
    setUserGroups(response.data);
  };

  useEffect(() => {
    getUser();

    getRoles();
    setRole();
    // refreshToken(); s
  }, []);
  const setRole = () => {
    // console.log(userGroups.find(role=>role.id===userGroupId))
    setUserRole(userGroups.find((role) => role.id == userGroupId));
  };

  return (
    <div className="content-wrappers">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>User Detail</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item active">User Detail</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid" center>
          <div className="row">
            <div className="col-md-2 "></div>
            <div className="col-md-8 ">
              <div className="card card-primary card-outline">
                <div className="card-body box-profile">
                  <div className="text-center">
                    <img
                      className="profile-user-img img-fluid img-circle"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/uploads/" +
                        selectedImage
                      }
                      alt="User profile picture"
                    />
                   
                  </div>

                  <h3 className="profile-username text-center">
                    {firstName} {lastName}{" "}
                  </h3>
                
                  <p className="text-muted text-center">
                    {phoneNumber} / {gender}{" "}
                  </p>
                  <p className="text-muted text-center">{address} </p>

                  <ul className="list-group list-group-unbordered mb-3">
                    <li className="list-group-item">
                      <b>Email</b> <a className="float-right">{email}</a>
                    </li>
                    <li className="list-group-item">
                      <b>Role</b>{" "}
                      <a className="float-right">{userRole && userRole.name}</a>
                    </li>
                    <li className="list-group-item">
                      <b>Status</b> <a className="float-right">{status}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewUser;
